import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import ProductCategoriesComponent from "./component";
import { useNavigate } from "react-router-dom";

const ProductCategoriesContainer = (props) => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  // S3 Base URL
  const S3_BASE_URL = "https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/";

  // Default images
  const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop";

  // Get user role from localStorage
  const user = JSON.parse(localStorage.getItem("data") || "{}");
  const userRole = user?.details?.userRole?.role_id;
  const canPerformActions = userRole !== 15;

  // Helper function to get full image URL
  const getFullImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
      return imagePath;
    }
    return `${S3_BASE_URL}${imagePath}`;
  };

  // Search handler
  const handleSearchChange = (value) => {
    setSearchTerm(value);
  };

  // Filter based on search
  useEffect(() => {
    let filtered = [...categories];
    
    if (searchTerm.trim()) {
      filtered = filtered.filter((category) => {
        const name = (category.name || "").toLowerCase();
        return name.includes(searchTerm.toLowerCase());
      });
    }
    
    setFilteredData(filtered);
  }, [searchTerm, categories]);

  // Fetch categories data
  const fetchCategories = () => {
    setLoading(true);

    props.getDataFromAPI(
      "/partner/api/v1/product-categories",
      "GET",
      undefined,
      (response) => {
        let categoriesData = [];

        if (response?.data && Array.isArray(response.data)) {
          categoriesData = response.data;
        } else if (response && Array.isArray(response)) {
          categoriesData = response;
        } else if (response?.categories && Array.isArray(response.categories)) {
          categoriesData = response.categories;
        } else if (response?.content && Array.isArray(response.content)) {
          categoriesData = response.content;
        }

        const formattedCategories = categoriesData.map(item => ({
          id: item.id || item._id,
          name: item.name,
          description: item.description || "",
          status: item.status === "active" || item.active === true ? "Active" : "Inactive",
          image_url: getFullImageUrl(item.image_url || item.imagePath || item.image) || DEFAULT_IMAGE,
          subCategories: item.subCategories || item.subcategories || [],
        }));

        setCategories(formattedCategories);
        setFilteredData(formattedCategories);
        setLoading(false);
      },
      (err) => {
        console.log("Error fetching categories:", err);
        toastr.error("Failed", "Unable to fetch product categories");
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Create new category
  const handleCreateCategory = () => {
    navigate("/home/product/categories/create");
  };

  // Edit category
  const handleEditCategory = (category) => {
    navigate(`/home/product/categories/edit/${category.id}`, {
      state: { categoryData: category }
    });
  };

  // Delete category
  const handleDeleteCategory = (category) => {
    if (window.confirm(`Are you sure you want to delete "${category.name}"?`)) {
      setLoading(true);
      
      props.getDataFromAPI(
        `/partner/api/v1/product-categories/${category.id}`,
        "DELETE",
        undefined,
        (response) => {
          toastr.success("Success", "Category deleted successfully");
          fetchCategories();
        },
        (err) => {
          console.log("Error deleting category:", err);
          toastr.error("Failed", "Unable to delete category");
          setLoading(false);
        }
      );
    }
  };

  // Category click - view subcategories
  const handleCategoryClick = (category) => {
    navigate(`/home/product/categories/subcategories/${category.id}`, {
      state: { categoryData: category }
    });
  };

  return (
    <ProductCategoriesComponent
      categories={filteredData}
      loading={loading}
      searchTerm={searchTerm}
      setSearchTerm={handleSearchChange}
      onCreateCategory={handleCreateCategory}
      onEditCategory={handleEditCategory}
      onDeleteCategory={handleDeleteCategory}
      onCategoryClick={handleCategoryClick}
      canPerformActions={canPerformActions}
    />
  );
};

function mapStateToProps(state) {
  return {
    props: state,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(ProductCategoriesContainer);